import * as React from 'react';
import { FC } from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { useTranslate } from 'react-admin';

interface Props {
    cities?: any;
}

const useStyles = makeStyles(theme => ({
    root: {
        flex: 1,
    },
    cost: {
        marginRight: '1em',
        color: theme.palette.text.primary,
    },
}));

const numFormatter: any = (num:any) => {
    if(num > 999 && num < 1000000){
        return (num/1000).toFixed(0) + 'K'; // convert to K for number from > 1000 < 1 million 
    }else if(num > 1000000){
        return (num/1000000).toFixed(0) + 'M'; // convert to M for number from > 1 million 
    }else if(num < 900){
        return num; // if value < 1000, nothing to do
    }
}
const TopCities: FC<Props> = ({ cities = []}) => {
    const classes = useStyles();
    const translate = useTranslate();
    return (
        <Card className={classes.root}>
            <CardHeader title={translate('pos.dashboard.top_cities')} />
            <List dense={true}>
                {cities.map((record : any) => (
                    <ListItem
                        key={record.id}
                        button
                        component={Link}
                        to={`#'`}
                    >
                        
                        <ListItemText
                            secondary={record.town_or_city===null ? "NULL" : record.town_or_city}
                            style={{ paddingRight: 0 }}
                        />
                        <ListItemSecondaryAction>
                            <span className={classes.cost}>
                                 {numFormatter(record.total)}
                            </span>
                        </ListItemSecondaryAction>
                    </ListItem>
                ))}
            </List>
        </Card>
    );
};

export default TopCities;
